// extracted by mini-css-extract-plugin
export default {"modal__delete":"style_modal__delete__XVM+k","modal__delete_btns":"style_modal__delete_btns__af8gC"};